export function clearSavedListParams(){
    Object.keys(localStorage)
        .filter(x =>
            x.startsWith('list_'))
        .forEach(x =>
            localStorage.removeItem(x))
}